import { getStopApi } from '../../../../../../services/StopApi/StopApi';

export const getCmpList = async ({
  commonParams,
  authorization,
  getCommunityBasedProviderName,
  getCounselingStaffAssignedName,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        cmpId: item.cmpId,
        communityBasedProviderName: getCommunityBasedProviderName(
          item.communityBasedProvider
        ),
        counselingStaffAssignedName: getCounselingStaffAssignedName(
          item.counselingStaffAssigned
        ),
      })),
    };
  }).catch((e) => alert(e));
};
